import { render } from "./SelectFacilityModal.vue?vue&type=template&id=06e6e0b0&scoped=true&ts=true"
import script from "./SelectFacilityModal.vue?vue&type=script&lang=ts"
export * from "./SelectFacilityModal.vue?vue&type=script&lang=ts"

import "./SelectFacilityModal.vue?vue&type=style&index=0&id=06e6e0b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e6e0b0"]])

export default __exports__